jQuery(document).ready(function($) {
    // Handle both current and past tips load more buttons
    var currentButton = $('#load-more-current-tips-user-stats');
    var pastButton = $('#load-more-past-tips-user-stats');

    if (currentButton.length === 0 && pastButton.length === 0) {
        return;
    }

    // Helper function to intelligently merge tips and prevent duplicate date headers
    function mergeTipsIntelligently(containerSelector, newHtml) {
        var container = $(containerSelector);
        var tempDiv = $('<div>').html(newHtml);
        
        // Find all date groups in the new HTML
        var newDateGroups = tempDiv.find('.post-group');
        
        newDateGroups.each(function() {
            var newDateGroup = $(this);
            var newDateTitle = newDateGroup.find('.tips_group_title .tips_group_label').text().trim();
            var newTips = newDateGroup.find('.tip-secondary-cards').children();
            
            // Look for existing date group with the same date
            var existingDateGroup = container.find('.post-group').filter(function() {
                var existingDateTitle = $(this).find('.tips_group_title .tips_group_label').text().trim();
                // Normalize both dates for comparison (remove extra spaces, normalize case)
                var normalizedExisting = existingDateTitle.replace(/\s+/g, ' ').toLowerCase();
                var normalizedNew = newDateTitle.replace(/\s+/g, ' ').toLowerCase();
                return normalizedExisting === normalizedNew;
            });
            
            if (existingDateGroup.length > 0) {
                // Date already exists, append tips to existing group
                var existingTipsContainer = existingDateGroup.find('.tip-secondary-cards');
                existingTipsContainer.append(newTips);
            } else {
                // New date, append the entire group
                container.append(newDateGroup);
            }
        });
    }

    // Event handler for current tips load more button
    $(document).on('click', '.load_more_posts_user_stats#load-more-current-tips-user-stats', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var button = $(this);
        var offset = parseInt(button.data('tips-shown')) || 0;
        var authorId = parseInt(button.data('author-id')) || 0;
        var isAuthorPage = button.attr('is_author_page') === '1' || button.attr('is_author_page') === 'true';

        // Add loading state
        button.addClass('active');
        button.prop('disabled', true);

        $.ajax({
            url: myAjax.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: {
                action: 'cards',
                function: 'loadMoreCurrentTipsForUserStats',
                offset: offset,
                author_id: authorId,
                is_author_page: isAuthorPage ? 1 : 0,
                nonce: myAjax.nonce || ''
            },
            success: function(response) {
                button.removeClass('active');
                button.prop('disabled', false);

                if (response.success && response.data) {
                    // Intelligently merge the new tips to prevent duplicate date headers
                    if (response.data.html) {
                        mergeTipsIntelligently('#current-tips-container-user-stats', response.data.html);
                    }

                    // Update the button data
                    if (response.data.new_offset !== undefined) {
                        button.data('tips-shown', response.data.new_offset);
                    }

                    // Hide button if no more tips to load
                    if (response.data.has_more === false) {
                        button.hide();
                    }
                }
            },
            error: function(xhr, status, error) {
                button.removeClass('active');
                button.prop('disabled', false);
            }
        });
    });

    // Event handler for past tips load more button
    $(document).on('click', '.load_more_posts_user_stats#load-more-past-tips-user-stats', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var button = $(this);
        var offset = parseInt(button.data('tips-shown')) || 0;
        var authorId = parseInt(button.data('author-id')) || 0;
        var isAuthorPage = button.attr('is_author_page') === '1' || button.attr('is_author_page') === 'true';

        // Add loading state
        button.addClass('active');
        button.prop('disabled', true);

        $.ajax({
            url: myAjax.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: {
                action: 'cards',
                function: 'loadMorePastTipsForUserStats',
                offset: offset,
                author_id: authorId,
                is_author_page: isAuthorPage ? 1 : 0,
                nonce: myAjax.nonce || ''
            },
            success: function(response) {
                button.removeClass('active');
                button.prop('disabled', false);

                if (response.success && response.data) {
                    // Intelligently merge the new tips to prevent duplicate date headers
                    if (response.data.html) {
                        mergeTipsIntelligently('#past-tips-container-user-stats', response.data.html);
                    }

                    // Update the button data
                    if (response.data.new_offset !== undefined) {
                        button.data('tips-shown', response.data.new_offset);
                    }

                    // Hide button if no more tips to load
                    if (response.data.has_more === false) {
                        button.hide();
                    }
                }
            },
            error: function(xhr, status, error) {
                button.removeClass('active');
                button.prop('disabled', false);
            }
        });
    });
});